import React from "react";

const Devider = () => {
  return <hr className="mt-5 border-secondary  opacity-25"></hr>;
};

export default Devider;
